import { render, staticRenderFns } from "./thanks.vue?vue&type=template&id=74f6fde2"
import script from "./thanks.vue?vue&type=script&lang=js"
export * from "./thanks.vue?vue&type=script&lang=js"
import style0 from "./thanks.vue?vue&type=style&index=0&id=74f6fde2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports